import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = ["target"];
const _hoisted_2 = {
  class: "ico-sidebar"
};
const _hoisted_3 = ["src", "alt"];
const _hoisted_4 = ["src", "alt"];
const _hoisted_5 = {
  class: "nav-link-text"
};
const _hoisted_6 = {
  class: "w-100"
};
const _hoisted_7 = {
  class: "nav nav-sm flex-column"
};
const _hoisted_8 = {
  key: 0,
  class: "ico-sidebar"
};
const _hoisted_9 = ["src", "alt"];
const _hoisted_10 = ["src", "alt"];
const _hoisted_11 = {
  class: "nav-link-text"
};
const _hoisted_12 = {
  key: 1,
  class: "new-module-label"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_collapse = _resolveComponent("b-collapse");
  const _component_router_link = _resolveComponent("router-link");
  return _openBlock(), _createElementBlock("li", {
    class: _normalizeClass(["nav-item", {
      active: $data.showCollapse
    }])
  }, [!$props.link.path ? (_openBlock(), _createElementBlock("a", {
    key: 0,
    onClick: _cache[0] || (_cache[0] = $event => {
      $data.showCollapse = !$data.showCollapse;
      _ctx.$emit('click-menu');
    }),
    class: "nav-link",
    target: $props.link.target
  }, [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_2, [_createElementVNode("img", {
    width: "22",
    class: "menu-default",
    src: require('@/assets/img/icons/menu/' + $props.link.icon + '.svg'),
    alt: $props.link.name
  }, null, 8, _hoisted_3), _createElementVNode("img", {
    width: "22",
    class: "menu-hover",
    src: require('@/assets/img/icons/menu/' + $props.link.icon + '-hover.svg'),
    alt: $props.link.name
  }, null, 8, _hoisted_4)]), _createElementVNode("span", _hoisted_5, _toDisplayString($props.link.name), 1)])], 8, _hoisted_1)) : _createCommentVNode("", true), !$props.link.path ? (_openBlock(), _createBlock(_component_b_collapse, {
    key: 1,
    id: $props.link.name.replace(' ', ''),
    modelValue: $data.showCollapse,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.showCollapse = $event)
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createElementVNode("ul", _hoisted_7, [_renderSlot(_ctx.$slots, "default")])])]),
    _: 3
  }, 8, ["id", "modelValue"])) : (_openBlock(), _createBlock(_component_router_link, {
    key: 2,
    class: "nav-link",
    target: $props.link.target,
    href: $props.link.path,
    to: $props.link.path,
    onClick: _cache[2] || (_cache[2] = $event => $options.clickRefresh($props.link.path))
  }, {
    default: _withCtx(() => [$props.link.icon ? (_openBlock(), _createElementBlock("span", _hoisted_8, [_createElementVNode("img", {
      width: "22",
      class: "menu-default",
      src: require('@/assets/img/icons/menu/' + $props.link.icon + '.svg'),
      alt: $props.link.name
    }, null, 8, _hoisted_9), _createElementVNode("img", {
      width: "22",
      class: "menu-hover",
      src: require('@/assets/img/icons/menu/' + $props.link.icon + '-hover.svg'),
      alt: $props.link.name
    }, null, 8, _hoisted_10)])) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_11, _toDisplayString($props.link.name), 1), $props.newModule ? (_openBlock(), _createElementBlock("span", _hoisted_12, "New")) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["target", "href", "to"]))], 2);
}